import { css } from 'lit';

export default css`
  :host {
    width: 100%;
    height: 100%;
  }

  input[type='file'] {
    display: none;
  }

  /** Add orders to box */
  .layout__box--one::after,
  .layout__box--two::after,
  .layout__box--three::after,
  .layout__box--four::after {
    width: 100%;
    height: 100%;
    font-size: 22px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--amityeko-color-gray-5);
  }

  .layout__box--one::after {
    content: var(--private-content-one, '1');
  }

  .layout__box--two::after {
    content: var(--private-content-two, '2');
  }

  .layout__box--three::after {
    content: var(--private-content-three, '3');
  }

  .layout__box--four::after {
    content: var(--private-content-four, '4');
  }

  .layout__box--one:hover amityeko-avatar,
  .layout__box--two:hover amityeko-avatar,
  .layout__box--three:hover amityeko-avatar,
  .layout__box--four:hover amityeko-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  amityeko-avatar {
    display: none;
  }

  .layout {
    width: var(--private-layout-width, 200px);
    height: var(--private-layout-height, 200px);
    display: flex;
  }

  .layout__box {
    width: 100%;
    height: 100%;
    cursor: var(--private-cursor);
    background-color: var(--amityeko-color-gray-8);
    border: 2px solid var(--amityeko-color-font-light);
  }

  /* layout Square and Circle css*/
  .layout--square,
  .layout--circle {
    align-items: center;
    justify-content: center;
  }

  .layout--square .layout__label,
  .layout--circle .layout__label {
    width: 100%;
    height: 100%;
    cursor: var(--private-cursor);
  }

  .layout--circle .layout__box {
    border-radius: 50%;
  }

  /** layout Square3H css */
  .layout--square-3h {
    flex-direction: column;
  }

  .layout--square-3h .layout__three__label {
    width: 100%;
    height: 30%;
  }

  /** layout Sqaure1H2S css */
  .layout--square-1h2s {
    flex-direction: column;
  }

  .layout--square-1h2s > .layout__label {
    width: 100%;
    height: 100%;
  }

  .layout__row__two {
    width: 100%;
    height: 100%;
    display: flex;
  }

  /** layout Square4S css */
  .layout--square-4s {
    flex-wrap: wrap;
  }

  .layout--square-4s .layout__label {
    width: 50%;
    height: 50%;
  }

  /** layout Square1V3S css */
  .layout--square-1v3s > label {
    width: 60%;
    height: 100%;
  }

  .layout__col__two {
    width: 40%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .layout__label {
    width: 100%;
    height: 100%;
  }
`;
